import {
  Directive,
  ElementRef,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { BlurService } from '../../service/blur.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[infBlurText]',
  standalone: true,
})
export class BlurDirective implements OnInit, OnDestroy {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  private blurService = inject(BlurService);
  private subscription: Subscription;

  @Input() infBlurText: boolean;

  ngOnInit() {
    if (!this.infBlurText) {
      return;
    }
    this.subscription = this.blurService.isBlurEnable$.subscribe({
      next: (isEnable) => {
        if (isEnable) {
          this.renderer.setStyle(this.el.nativeElement, 'filter', 'blur(4px)');
          this.renderer.setStyle(this.el.nativeElement, 'user-select', 'none');
          return;
        }
        this.renderer.removeStyle(this.el.nativeElement, 'filter');
        this.renderer.removeStyle(this.el.nativeElement, 'user-select');
      },
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
